import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonInput, ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppComponent } from '../../app.component';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import Address from '../../../smoothr-web-app-core/models/Address';
import { MapsUtils } from '../../../smoothr-web-app-core/utils/maps-utils';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { sleep, venueAcceptsOrders } from '../../../smoothr-web-app-core/utils/utils';
import AutocompletePrediction = google.maps.places.AutocompletePrediction;
import { environment } from 'src/environments/environment';
import { calculateGeoDistance } from 'src/maps/utils/maps';

@Component({
	selector: 'app-check-delivery-radius-modal',
	templateUrl: './check-delivery-radius-modal.component.html',
	styleUrls: ['check-delivery-radius-modal.component.scss'],
})
export class CheckDeliveryRadiusModalComponent extends RepositoryDirective implements OnInit, AfterViewInit {
	@ViewChild(IonInput, { static: true }) inputField: IonInput;
	@Input() selectedVenue: Venue;
	loading = false;
	venuesLoaded = false;
	searchTerm: string;
	address: Address;
	showEmpty = false;
	suggestedPlace: Address;
	deliveryVenueAvailable = false;
	predictions: AutocompletePrediction[] = [];
	addressToString = MapsUtils.addressToString;
	inputValue = '';
	myAddress: Address;
	allVenues: Venue[] = [];
	closestVenue: Venue | null = null;
	constructor(
		protected repository: RepositoryService,
		private translate: TranslateService,
		private router: Router,
		private snackbarCtrl: MatSnackBar,
		private snackBar: MatSnackBar,
		private cdr: ChangeDetectorRef,
		private modalCtrl: ModalController,
		public platform: Platform
	) {
		super(repository);
	}

	static async show(
		modalCtrl: ModalController,
		address: Address = null,
		venue: Venue = null
	): Promise<{ venue?: Venue; address?: Address; closest?: Venue }> {
		const modal = await modalCtrl.create({
			component: CheckDeliveryRadiusModalComponent,
			cssClass: 'delivery-modal',
			componentProps: {
				myAddress: address,

				selectedVenue: venue,
				address: address,
			},
		});
		await modal.present();
		const result = await modal.onDidDismiss();
		await sleep(100);
		return result.data;
	}

	async ngOnInit() {
		MapsUtils.getUserGeocode().then(result => {
			this.suggestedPlace = result;
		});
		await this.initAutocomplete();
	}

	largeScreen(): boolean {
		return AppComponent.largeScreen;
	}

	async loadPlace(pred: AutocompletePrediction) {
		if (this.loading) {
			return;
		}
		this.loading = true;

		this.inputValue = pred.description;
		try {
			const result = await MapsUtils.getPlaceByPred(pred);
			await this.fillInPlace(await MapsUtils.placeToAddress(result));
			this.predictions = [];
		} catch (e) {
			// await this.fillInPlace(pred);
		}

		this.loading = false;
		this.cdr.detectChanges();
	}

	async resetSearch() {
		(await this.inputField.getInputElement()).value = '';
		this.searchTerm = '';
		this.venuesLoaded = false;
		this.deliveryVenueAvailable = false;
		this.predictions = [];
	}

	async loadVenues(address: Address) {
		console.log('selectedVenue', this.selectedVenue);
		this.deliveryVenueAvailable = false;
		this.venuesLoaded = false;
		// if (address.street === null || address.street === undefined) {
		// 	this.address = null;
		// 	this.loading = false;
		// 	this.snackBar.open(this.translate.instant('home_page.street_error'), null, {
		// 		duration: 2000,
		// 	});
		// 	this.cdr.detectChanges();
		// 	return;
		// }
		try {
			const foundVenue = (await this.repository.getVenuesByAddress(environment.customerGroup, address)).find(ven =>
				venueAcceptsOrders(ven, PreorderType.DELIVERY)
			);

			this.deliveryVenueAvailable = foundVenue !== undefined;
			this.venuesLoaded = true;

			if (!foundVenue) {
				this.closestVenue = this.getClosestVenue(this.allVenues, address);
			}
		} catch (e) {
			console.error(e);
			this.venuesLoaded = false;
		}
		this.loading = false;
		this.cdr.detectChanges();
	}
	chooseClosestVenue() {
		this.modalCtrl.dismiss({
			closest: this.closestVenue,
		});
	}

	getClosestVenue(venues: Venue[], address: Address): Venue | null {
		if (!venues.length) return null;

		let closest = venues[0];
		let minDistance = calculateGeoDistance(address.lat, address.lng, closest.location.coordinates[1], closest.location.coordinates[0]);

		for (let i = 1; i < venues.length; i++) {
			const distance = calculateGeoDistance(
				address.lat,
				address.lng,
				venues[i].location.coordinates[1],
				venues[i].location.coordinates[0]
			);
			if (distance < minDistance) {
				minDistance = distance;
				closest = venues[i];
			}
		}

		return closest;
	}
	async fillInPlace(address: Address) {
		if (!address) {
			return;
		}
		if (!address?.lat) {
			try {
				const result = await MapsUtils.getPlaceByPred(address as any);
				console.log('RESUlt of mapping', result);
				address = MapsUtils.placeToAddress(result as any);
			} catch (e) {
				this.loading = false;
				return;
			}
		}
		this.loading = true;
		try {
			await MapsUtils.fillInPlace(this.inputField, address, term => {
				if (term) {
					this.searchTerm = term;
				}
				return this.searchTerm;
			});
			if (!address) {
				await this.executeSearch();
				return;
			}
			this.address = address;
			await this.loadVenues(address);
			this.loading = false;
		} catch (e) {
			this.snackBar.open(this.translate.instant('check_delivery.address_error'), null, {
				duration: 2000,
			});
		}
		this.loading = false;
		this.cdr.detectChanges();
	}

	async dismiss(address: Address) {
		this.modalCtrl.dismiss({
			selectedVenue: this.selectedVenue,
			address,
		});
	}

	async executeSearch() {}
	async ngAfterViewInit() {
		const inputElement = await this.inputField.getInputElement();
		inputElement.focus(); // Ensure the input is focused when the page loads
	}

	async initAutocomplete() {
		// this.showEmpty = false;
		// if (this.inputField) {
		// 	await MapsUtils.initAutocomplete(this.inputField, async predictions => {
		// 		this.predictions = predictions;
		// 		this.showEmpty = predictions.length === 0;
		// 		console.log(this.predictions)
		// 		this.cdr.detectChanges();
		// 	});
		// }
		// this.loading = false;
	}

	async delivery() {
		await this.modalCtrl.dismiss({
			venue: this.selectedVenue,
			address: this.address,
		});
	}

	async close() {
		await this.modalCtrl.dismiss();
	}

	result: Address;

	async changeValue(value: any) {
		this.predictions = [];
		this.loading = true;
		this.selectedVenue = null;
		try {
			const result = await MapsUtils.getValue(this.inputField, pred => {
				console.log(pred);
			});
			if (result?.predictions) {
				this.predictions = result?.predictions;
			} else {
				this.predictions = [];
			}
		} catch (e) {}
		this.loading = false;
		this.cdr.detectChanges();

		this.searchTerm = value.detail.value;

		await sleep(500);
		this.inputField.setFocus();
	}
}
